module.exports = __webpack_public_path__ + "static/media/LIMP GERAL PRATIC.756133dc.png";